import React from "react";

import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Link from "../Link";
// styles
import css from "./Breadcrumbs.module.scss";

export interface Page {
	/**
	 * Unique ID for the page
	 */
	pageID: string;
	/**
	 * Label to display for the page
	 */
	label: string | React.ReactNode;
	/**
	 * URL to navigate to when the page is clicked
	 */
	url: string;
}

interface BaseProps {
	/**
	 * The pages to display in the breadcrumbs
	 */
	pages: Page[];
	/**
	 * Optional class name to apply to the container
	 * @default
	 */
	className?: string;
	/**
	 * Optional forceHardReload prop to pass to the Link component
	 */
	forceHardReload?: boolean;
}

/**
 * Renders a breadcrumb trail to provide context to the user and allow them to
 * navigate back to previous pages.
 */
const Breadcrumbs = (props: BaseProps) => {
	const { pages, className, forceHardReload = false } = props;
	return (
		<div className={`${css.container} ${className}`}>
			{pages.map((page, index) => {
				const isLastBreadcrumb = index === pages.length - 1;
				return (
					<div {...{ "data-testid": page.pageID }} key={page.pageID} className={css.page}>
						<div>
							{isLastBreadcrumb ? (
								<div>{page.label}</div>
							) : (
								<Link
									forceHardReload={forceHardReload}
									className={`${css.url}`}
									href={page.url}
									hideInternalCard
								>
									{page.label}
								</Link>
							)}
						</div>
						{!isLastBreadcrumb ? (
							<div className={css.icon}>
								<FontAwesomeIcon icon={faChevronRight} />
							</div>
						) : null}
					</div>
				);
			})}
		</div>
	);
};

export default Breadcrumbs;
